import angular from 'angular';
import '../core.module';

class ChannelsApiService {
  constructor($http, API_BASE_URL) {
    this.$http = $http;
    this.API_BASE_URL = API_BASE_URL;
  }

  list() {
    return this.$http.get(`${this.API_BASE_URL}/channels`).then((response) =>
      response.data.map((channel) => ({
        id: channel.id,
        name: channel.name,
        connectorName: channel.connector_name,
        connectorProvider: channel.connector_provider,
        status: channel.status,
        aiAgent: channel.ai_agent_id
          ? {
              id: channel.ai_agent_id,
              name: channel.ai_agent_name,
              ready: Boolean(channel.ai_agent_ready)
            }
          : null
      }))
    );
  }
}

ChannelsApiService.$inject = ['$http', 'API_BASE_URL'];

angular.module('app.core').service('ChannelsApiService', ChannelsApiService);

export default ChannelsApiService;
